// src/data/faqData.js

export const faqMeta = {
  heading: "Answered with Honesty",
};

export const faqList = [
  {
    id: 1,
    question: "Do you provide bulk customization for Notebooks, Journals, and Diaries?",
    answer: "Yes, we specialize in bulk customization. You can personalize our premium notebooks, journals, and diaries with your company logo, custom covers, and personalized name engraving for employees or clients."
  },
  {
    id: 2,
    question: "What types of Corporate Gift Hampers do you offer?",
    answer: "Our corporate gift hampers are highly curated. We offer everything from tech hampers to stationary kits which can include a mix of notepads, sketchbooks, premium pens, and personalized table calendars tailored to your budget."
  },
  {
    id: 3,
    question: "Can I customize a Photo Book or Album for company milestones?",
    answer: "Absolutely! Our customizable photo books and albums are perfect for corporate anniversaries, team offsites, or farewell gifts. You can choose the layout, cover material, and print quality."
  },
  {
    id: 4,
    question: "Are your Table Calendars suitable for new year corporate gifting?",
    answer: "Yes, our table calendars are a best-seller for New Year gifting. We can customize them with your brand colors, inspiring quotes, and highlight important company dates throughout the year."
  },
  {
    id: 5,
    question: "Can we include Travel Books and Sketchbooks in employee welcome kits?",
    answer: "Definitely. Travel books and sketchbooks add a thoughtful, creative touch to employee onboarding kits. We can bundle them with matching notepads and diaries for a complete look."
  },
  {
    id: 6,
    question: "What is the minimum order quantity (MOQ) for these customized products?",
    answer: "The MOQ varies by product. Generally, for custom notebooks, journals, and corporate gift hampers, the minimum order starts at 50 units. Please contact our bulk enquiry team for specific details."
  }
];  